import type { ErrorInfo } from "@octopusdeploy/design-system-components";
import { OctopusError } from "@octopusdeploy/octopus-server-client";
export function createErrorInfo(error: Error | OctopusError | null | undefined): ErrorInfo | undefined {
    if (!error) {
        return undefined;
    }
    const isOctopusError = OctopusError.isOctopusError(error);
    return {
        message: isOctopusError ? error.ErrorMessage : error?.message,
        help: isOctopusError
            ? {
                link: error.HelpLink,
            }
            : undefined,
        details: isOctopusError
            ? (error.Errors || [])
                .filter((x) => !!x)
                .map((s) => ({
                text: s,
            }))
            : [],
    };
}
